import { render, staticRenderFns } from "./AlbumsEdit.vue?vue&type=template&id=16375c9a&scoped=true"
import script from "./AlbumsEdit.vue?vue&type=script&lang=js"
export * from "./AlbumsEdit.vue?vue&type=script&lang=js"
import style0 from "./AlbumsEdit.vue?vue&type=style&index=0&id=16375c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16375c9a",
  null
  
)

export default component.exports